/**
 * キッズコース（金曜16:40〜17:50）の募集状態を一元管理する設定。
 * 満枠になったら remainSlot のみ更新すれば、時間割の残席表示・満員切替・メタ説明文が連動する。
 * ageRangeText 等の商品条件が変わる場合は、そのフィールドも合わせて更新する。
 *
 * remainSlot はエレメンタリーコース（小学1〜3年生）とも共有する（同一の教室・講師キャパシティを
 * 分け合う単一の物理制約のため）。エレメンタリーコース側で独立した remainSlot は持たせない。
 */
export const ClassKidsRecruitment = {
  remainSlot: 2,
  ageRangeText: '３歳頃 ~ 就学前',
  weekday: '金',
  startTime: '16:40',
  endTime: '17:50',
  enrollmentTiming: 'いつでも',
} as const;

const toFullWidthDigits = (value: number): string =>
  value.toString().replace(/[0-9]/g, (digit) => String.fromCharCode(digit.charCodeAt(0) + 65248));

/**
 * サイト内導線（トップ通知・ブログCTA等）の募集状況テキストを remainSlot から生成する。満員時は「満員」を返す。
 * remainSlot は既定で ClassKidsRecruitment.remainSlot（正本）を使うが、テストで分岐を検証できるよう引数で上書き可能にする。
 */
export const classKidsRecruitmentStatusText = (remainSlot: number = ClassKidsRecruitment.remainSlot): string =>
  remainSlot === 0 ? '満員' : `${toFullWidthDigits(remainSlot)}名募集中`;
